export function storeRestaurantDetail(data) {
    return{
        type: 'STORE_RESTAURANT_DETAIL',
        payload: data
    }
}
